import {ReportTableActionMenuTypesEnum, ReportTableColumn, ReportTableConfigInterface} from 'appShared/components/report-table';
import {BaseControl, propertyOf} from 'appShared/classes';
import {ConstraintsCollection, ExchangeFilterModel, ExchangeInterface, ReportFilterConstraintsEnum} from '@spa/api';
import {DialogButtonTypesEnum, DialogConfigInterface, Pagination} from 'appShared/components';

export const PanelExchangesDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Name',
            selector: propertyOf<ExchangeInterface>('name'),
        }),
        new ReportTableColumn({
            label: 'Code',
            selector: propertyOf<ExchangeInterface>('code'),
        }),
        new ReportTableColumn({
            label: 'Report Start Day',
            selector: propertyOf<ExchangeInterface>('reportStartDay'),
        }),
        new ReportTableColumn({
            label: 'Report End Day',
            selector: propertyOf<ExchangeInterface>('reportEndDay')
        }),
        new ReportTableColumn({
            label: 'Agreement Types',
            selector: propertyOf<ExchangeInterface>('agreementTypes')
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false,
    actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
    actionMenuItems: []
};

export const RemoveExchangesControls = (): BaseControl<string | number | boolean>[] => {
    return [];
};

export const RemoveExchangeDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                hidden: true,
                customText: 'Remove'
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false,
        disabledCloseBtn: true
    };
};

export const defaultExchangeInitialFilterModel = (itemsPerPage = Pagination.defaultItemsPerPage) => {
    const filter = new ExchangeFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        ExchangeFilterModel.getCreatedTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );

    filter.addConstraintItem(
        ReportFilterConstraintsEnum.Equal,
        'deleted',
        'false'
    );

    return filter;
};
